import { API_BASES } from "../../config/apiConfig";
import { formatApiError } from "../../util/formatApiError";
import { showToast } from "../../util/appToast";

const BASE = API_BASES.EVENTS;

const parseJson = async (response, opts) => {
  opts = opts || {};
  var data = {};
  try {
    data = await response.json();
  } catch (_) {
    data = {};
  }
  if (!response.ok || data.success === false) {
    var error = formatApiError(data.message || data || "Request failed");
    if (!opts.silent && response.status !== 401) showToast(error, "error");
    throw new Error(error);
  }
  return data.payload || {};
};

const jsonFetch = async (path, options) => {
  options = options || {};
  var silent = !!options.silent;
  var rest = Object.assign({}, options);
  delete rest.silent;
  var response = await fetch(BASE + path, {
    headers: { "Content-Type": "application/json" },
    ...rest,
  });
  return parseJson(response, { silent: silent });
};

const staffFetch = async (path, token, options) => {
  options = options || {};
  var headers = Object.assign({}, options.headers || {});
  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = headers["Content-Type"] || "application/json";
  }
  if (token) headers.Authorization = "Bearer " + token;
  var response = await fetch(BASE + path, Object.assign({}, options, { headers: headers }));
  if (response.status === 401) {
    try {
      var mod = await import("../../Staff/session/staffSession");
      mod.setStaffToken(null);
      mod.setStaffPayload(null);
    } catch (_) {}
  }
  return parseJson(response, { silent: !!options.silent });
};

function qs(params) {
  var parts = [];
  Object.keys(params || {}).forEach(function (key) {
    var value = params[key];
    if (value === null || typeof value === "undefined" || value === "") return;
    parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
  });
  return parts.length ? "?" + parts.join("&") : "";
}

async function downloadBlob(token, path, filename) {
  var headers = {};
  if (token) headers.Authorization = "Bearer " + token;
  var res = await fetch(BASE + path, { headers: headers });
  if (!res.ok) {
    var detail = "";
    try {
      var data = await res.json();
      detail = data && data.message ? data.message : "";
    } catch (_) {}
    throw new Error(detail || "Unable to download document.");
  }
  var blob = await res.blob();
  var url = URL.createObjectURL(blob);
  var a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  return { ok: true };
}

export const sponsorApi = {
  bootstrap: function (eventKey) {
    var key = encodeURIComponent(eventKey || "");
    return jsonFetch("/sponsors/bootstrap/?event_id=" + key + "&slug=" + key);
  },
  submit: async function (eventKey, formData) {
    formData.append("event_id", eventKey);
    formData.append("slug", eventKey);
    var response = await fetch(BASE + "/sponsors/submit/?event_id=" + encodeURIComponent(eventKey), {
      method: "POST",
      body: formData,
    });
    return parseJson(response);
  },
  lookup: function (ref) {
    return jsonFetch("/sponsors/lookup/?ref=" + encodeURIComponent(ref), { silent: true });
  },
  staffList: function (token, params) {
    return staffFetch("/staff/sponsors/" + qs(params), token);
  },
  staffDetail: function (token, sponsorId) {
    return staffFetch("/staff/sponsors/" + encodeURIComponent(sponsorId) + "/", token);
  },
  staffUpdate: function (token, sponsorId, body) {
    return staffFetch("/staff/sponsors/" + encodeURIComponent(sponsorId) + "/update/", token, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  staffArchive: function (token, sponsorId) {
    return staffFetch("/staff/sponsors/" + encodeURIComponent(sponsorId) + "/archive/", token, {
      method: "POST",
      body: "{}",
    });
  },
  staffAddPayment: function (token, sponsorId, body) {
    return staffFetch("/staff/sponsors/" + encodeURIComponent(sponsorId) + "/payments/", token, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  staffVerifyPayment: function (token, paymentId, body) {
    return staffFetch("/staff/sponsors/payments/" + encodeURIComponent(paymentId) + "/verify/", token, {
      method: "POST",
      body: JSON.stringify(body || { approve: true }),
    });
  },
  staffUpdatePackage: function (token, packageId, body) {
    return staffFetch("/staff/sponsors/packages/" + encodeURIComponent(packageId) + "/", token, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  staffExport: function (token, params) {
    return downloadBlob(
      token,
      "/staff/sponsors/export/" + qs(params),
      "sponsors.csv"
    );
  },
  staffDocument: function (token, sponsorId, kind) {
    return downloadBlob(
      token,
      "/staff/sponsors/" + encodeURIComponent(sponsorId) + "/document/" + encodeURIComponent(kind) + "/",
      sponsorId + "-" + kind
    );
  },
};

export default sponsorApi;
